import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import { FlagCardProps } from './types';
import { StyledCard, IconWrapper, BlockingBadge, ActionButton } from './styles';
import { formatFlagName } from './utils';
import { ConfirmButtonResolveFlag } from 'components/inspection/photos/section/PhotoFlags';

const FlagCard: React.FC<FlagCardProps> = ({ flag, onResolve }) => {
  const isResolved = flag.status === 'resolved';
  const isBlocking = flag.category === 'BLOCKING';

  return (
    <StyledCard isBlocking={isBlocking} isResolved={isResolved}>
      {isBlocking && !isResolved && <BlockingBadge>Blocking</BlockingBadge>}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'flex-start',
          position: 'relative',
        }}
      >
        <IconWrapper
          color={isResolved ? '#2E7D32' : isBlocking ? '#D32F2F' : '#FB8C00'}
        >
          {isResolved ? (
            <CheckCircleIcon />
          ) : isBlocking ? (
            <WarningIcon />
          ) : (
            <InfoIcon />
          )}
        </IconWrapper>
        <Box sx={{ flex: 1, mr: !isResolved ? 7 : 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            {formatFlagName(flag.name)}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {flag.description}
          </Typography>
        </Box>
        {!isResolved && (
          <ActionButton>
            <ConfirmButtonResolveFlag
              onConfirm={onResolve}
              flagRule={flag.name}
            />
          </ActionButton>
        )}
      </Box>
    </StyledCard>
  );
};

export default FlagCard;
